import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { NameValue, Report } from '../../core/models';
import {
  ActivityFormatService, AgeGroupService, ArrayService, AuthService, ITPerformanceService,
  ChurchService, DatabaseService, DocumentService, FestivalUserService 
} from '../../core/services';

import { PageClass } from '../../core/classes/page';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.less', '../../core/styles/common.less']
})

export class DashboardComponent extends PageClass implements OnInit {

  reportList: Report[] = [];

  choirAwaitingApproval: number = 0;
  choirAwaitingPayment: number = 0;
  choirAwaitingResubmission: number = 0;

  theatreAwaitingApproval: number = 0;
  theatreAwaitingPayment: number = 0;
  theatreAwaitingResubmission: number = 0;

  constructor(
    protected activityFormatService: ActivityFormatService,
    protected itPerformanceService: ITPerformanceService,
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    protected documentService: DocumentService,
    protected modalController: ModalController,
    protected router: Router,
    protected festivalUserService: FestivalUserService,
    protected alertController: AlertController
  ) { 
    super(ageGroupService, arrayService, authService, churchService, databaseService, festivalUserService);
  }

  protected loadData = async () => {

    if (this.currentUser.isDeleted || !this.currentUser.isActive) {
      this.router.navigate(['/']);
    } else {
      this.isLoading = false;
    }
  }

  runQueries = async () => {
    if (this.currentUser.activityList.findIndex((a: NameValue) => a.value === 'Choir') > -1) {
      forkJoin()
    }
  }

  doRefresh = async (event: any) => {
    await this.loadData();
    event.target.complete();
  }

  openReport = (report: Report): void => {
    this.router.navigate(['/report', 'view', report.id, report.page]);
  }

  showErrorMessage = async (header: string, errorMessage: string) => {
    const alert = await this.alertController.create({
      header: header,
      message: errorMessage,
      buttons: ['OK'],
    });

    alert.onDidDismiss().then(() => { 
    });

    await alert.present();
  }
}
